module.exports = __webpack_public_path__ + "static/media/notextDesktopBanner.ec19cf4f.png";